<template>
  <tk-flex
    v-if="equipments.length === 0"
    class="width-full"
    style="height: 500px"
    middle
    center
  >
    <a-empty></a-empty>
  </tk-flex>
  <tk-flex
    v-else-if="!tagTrusted"
    class="width-full"
    style="height: 500px"
    middle
    center
  >
    <a-empty>
      <span slot="description">数据异常，可能由于通风或摄像头晃动引起异常</span>
    </a-empty>
  </tk-flex>
  <div v-else>
    <a-row type="flex" :gutter="[20, 20]" class="m-t-10">
      <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
        <div class="rounded-2xl height-full overflow-hidden bg-white" style="min-height: 400px; overflow:auto;">
          <a-skeleton :loading="isRequestPoint">
            <SummaryCard :dataSource="dataSource" :columns="columns" />
          </a-skeleton>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
        <div
          class="rounded-2xl overflow-hidden full-height"
          style="height: 400px;"
        >
          <a-card
            :loading="isRequestPoint"
            :bordered="false"
            style="height: 100%;"
          >
            <div class="bg-white">
              <div
                class="height-full grid bg-white p-x-15 bg-white items-center"
                style="height: 60px; grid-template-columns: 1fr auto 1fr; gap: 15px"
              >
                <tk-flex>
                  <tk-flex class="m-r-8" middle>
                    <div class="point-tag bug m-r-2"></div>
                    <span>有虫</span>
                  </tk-flex>
                  <tk-flex class="m-r-8" middle>
                    <div class="point-tag nobug m-r-2"></div>
                    <span>无虫</span>
                  </tk-flex>
                  <tk-flex class="m-r-8" middle>
                    <div class="point-tag notest m-r-2"></div>
                    <span>未检测到</span>
                  </tk-flex>
                </tk-flex>
                <div style="font-weight: 600;font-size:16px;">
                  粮虫检测点位图
                </div>
              </div>
              <div class="center" ref="pointsWarp" style="height: 340px;">
                <div
                  :style="{
                    width: piontWarpSize.width + 'px',
                    height: piontWarpSize.height + 'px'
                  }"
                >
                  <PointsList
                    :selectPoints="selectPoints"
                    :horizontal="width"
                    :vertical="height"
                    :isCircle="isCircle"
                    :eqPoints="eqPoints"
                    @changePoints="changePoints"
                    :diameter="isCircle ? storeInfo.diameter : 0"
                  />
                </div>
              </div>
            </div>
          </a-card>
        </div>
      </a-col>
    </a-row>
    <a-card class="m-t-20 p-x-15">
      <div
        class="height-full grid bg-white bg-white items-center"
        style="height: 60px; grid-template-columns: 1fr auto 1fr; gap: 15px"
      >
        <div></div>
        <div style="font-weight: 600;font-size:16px;">
          检测结果图
        </div>
        <div class="justify-self-end" style="width: 230px">
          <a-select
            mode="multiple"
            class="w-full"
            :maxTagCount="1"
            placeholder="所有点位"
            v-model="selectPoints"
          >
            <a-select-option
              v-for="item in allPonits"
              :key="item.originalId"
              :value="item.originalId"
            >
              {{ item.index }}号点位
            </a-select-option>
          </a-select>
        </div>
      </div>
      <a-row :gutter="[20, 20]">
        <a-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          :xl="4"
          :xxl="4"
          v-for="item in showPointsRes"
          :key="item.objectId"
        >
          <a-card size="small" :bordered="false" :loading="isRequestPoint">
            <PointInfo :item="item" class="rounded-2xl" ref="points" />
          </a-card>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import SummaryCard from './summaryCard'
import PointInfo from './pointInfo'
import PointsList from './points'
const squareRoot2 = 1.414

export default {
  props: {
    tagTrusted: {
      type: Boolean,
      required: true
    },
    storeInfo: {
      type: Object,
      required: true
    },
    allPonits: {
      type: Array,
      required: true
    },
    eqPoints: {
      type: Array,
      required: true
    },
    equipments: {
      type: Array,
      required: true
    },
    isRequestPoint: {
      type: Boolean,
      required: true
    },
    pointsRes: {
      type: Array,
      required: true
    },
    storeBugNum: {
      type: Number,
      required: true
    }
  },
  components: {
    SummaryCard,
    PointInfo,
    PointsList
  },
  data () {
    return {
      dataSource: [
        {
          key: '1',
          name: '象甲科（米象、玉米象等）',
          num: '--',
          density: '--'
        },
        {
          key: '2',
          name: '拟步甲科等（谷盗等）',
          num: '--',
          density: '--'
        },
        {
          key: '3',
          name: '飞蚁科',
          num: '--',
          density: '--'
        },
        {
          key: '4',
          name: '飞蛾科',
          num: '--',
          density: '--'
        },
        {
          key: '5',
          name: '飞蛾幼虫类',
          num: '--',
          density: '--'
        },
        {
          key: '6',
          name: '未识别害虫',
          num: '--',
          density: '--'
        },
        {
          key: '7',
          name: '总计',
          num: '--',
          density: '--'
        }
      ],
      columns: [
        {
          title: '粮虫种类',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '粮虫数量（只）',
          dataIndex: 'num',
          key: 'num'
        },
        {
          title: '粮虫密度（只/m³）',
          dataIndex: 'density',
          key: 'density'
        }
      ],
      selectPoints: [],
      pointsWarpWidth: 0,
      pointsWarpHeight: 0
    }
  },
  watch: {
    storeBugNum: {
      immediate: true,
      handler (newV) {
        this.dataSource[this.dataSource.length - 1].num = newV
      }
    },
    pointsRes () {
      this.selectPoints = []
    },
    isRequestPoint: {
      immediate: true,
      handler (newV) {
        if (!newV) {
          this.$nextTick(this.getPointsWarpSize)
        }
      }
    }
  },
  computed: {
    width () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.length
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    height () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.width
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    piontWarpSize () {
      const storeProportion = this.width / this.height
      const warpProportion = this.pointsWarpWidth / this.pointsWarpHeight
      let ret
      if (Number.isNaN(warpProportion)) {
        ret = {
          width: 0,
          height: 0
        }
      } else {
        if (storeProportion >= warpProportion) {
          ret = {
            width: this.pointsWarpWidth,
            height: this.pointsWarpWidth / storeProportion
          }
        } else {
          ret = {
            width: this.pointsWarpHeight * storeProportion,
            height: this.pointsWarpHeight
          }
        }
      }
      return ret
    },
    isCircle () {
      return this.storeInfo.type !== 'square'
    },
    showPointsRes () {
      if (this.selectPoints && this.selectPoints.length > 0) {
        return this.selectPoints.map(element => {
          return this.pointsRes.find(ele => element === ele.originalId)
        })
      } else {
        return this.pointsRes
      }
    }
  },
  methods: {
    getPointsWarpSize () {
      if (this.tagTrusted) {
        this.pointsWarpWidth = this.$refs.pointsWarp.offsetWidth
        this.pointsWarpHeight = this.$refs.pointsWarp.offsetHeight
      }
    },
    changePoints (id) {
      const index = this.pointsRes.findIndex(ele => id === ele.originalId)
      if (index > -1) {
        this.$refs.points[index].openDetails()
      }
      // const index = this.selectPoints.indexOf(id)
      // if (index > -1) {
      //   this.selectPoints.splice(index, 1)
      // } else {
      //   this.selectPoints.push(id)
      // }
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .ant-card-body {
  padding: 0px;
}
.center{
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.point-tag {
  width: 16px;
  height: 10px;
  border-radius: 2px;
  &.bug {
    background-color: #ee5729;
  }
  &.nobug {
    border: 1px solid #45eec4;
    background-color: #45eec4;
  }
  &.notest {
    background-color: #efeff0;
  }
}
</style>
